import Model from '@/store/model';
import Product from '@/store/models/subscriptions/braintree/product';
import SalesBaseModal from '@/components/shared/elements/modal/SalesBaseModal';
import SalesLargeModal from '@/components/shared/elements/modal/SalesLargeModal';
import SaleInfo from './sale_info';
import { time } from 'vue-gtag';

const IconCrown = () => import('@/components/shared/elements/icons/IconCrown');
const IconMicrophone = () => import('@/components/shared/elements/icons/IconProMicrophone');
const IconProfile = () => import('@/components/shared/elements/icons/IconProfile');
const IconProHearthRounded = () => import('@/components/shared/elements/icons/IconProHearthRounded');
const IconHeartRounded = () => import('@/components/shared/elements/icons/IconProHearthRounded');
const IconNewProCrown = () => import('@/components/shared/elements/icons/IconNewProCrown');
const IconProWordCategory = () => import('@/components/shared/elements/icons/IconProWordCategory');
const IconMinGrammar = () => import('@/components/shared/elements/icons/IconProMiniGrammar');
const IconCatalog = () => import('@/components/shared/elements/icons/IconProCatalog');
const IconGrammar = () => import('@/components/shared/elements/icons/IconProGrammar');
const IconSpeakbotVocabulary = () => import('@/components/shared/elements/icons/IconProSpeakbotVocabulary');
const IconProPronuncation = () => import('@/components/shared/elements/icons/IconProPronuncation');

class Promotion extends Model {
  map(json) {
    super.map(json);
    if (json && (json.best_deal_product || json.bestDealProduct)) {
      this.bestDealProduct = new Product();
      this.bestDealProduct.map(json.best_deal_product || json.bestDealProduct);
    }

    if (json && (json.sale_info || json.saleInfo)) {
      this.saleInfo = new SaleInfo();
      this.saleInfo.map(json.sale_info || json.saleInfo);
    }
  }

  getSalesPopup(type, ok, cancel, teacherPic = undefined) {
    let mainIconComponent = IconCrown;
    let needRotatedCrown = false;
    let modalType = SalesBaseModal;
    let congratulationText = null;
    const okText = this.getCtaLabel();
    let fullScreenDescription = null;
    let percentageOff = null;
    let backgroundUrl = null;
    let isGeneralStyle = true;
    let renewHint = null;
    let upperPicture = null;
    let needFindOutMoreButton = true;
    let userInManualSale = null;
    let teacherPicture = null;
    switch (type) {
      case 'checkpoint':
        mainIconComponent = IconProHearthRounded;
        needRotatedCrown = true;
        break;
      case 'pronuncation':
        mainIconComponent = IconProPronuncation;
        needRotatedCrown = true;
        break;
      case 'favourite':
        mainIconComponent = IconHeartRounded;
        needRotatedCrown = true;
        break;
      case 'expressionTags':
        mainIconComponent = IconProWordCategory;
        needRotatedCrown = true;
        break;
      case 'miniGrammar':
        mainIconComponent = IconMinGrammar;
        needRotatedCrown = true;
        break;
      case 'catalog':
        mainIconComponent = IconCatalog;
        needRotatedCrown = true;
        break;
      case 'speakbot':
        mainIconComponent = IconMicrophone;
        needRotatedCrown = true;
        break;
      case 'grammar':
        mainIconComponent = IconGrammar;
        needRotatedCrown = true;
        break;
      case 'profileAvatar':
        mainIconComponent = IconProfile;
        needRotatedCrown = true;
        break;
      case 'speakbotVocabulary':
        mainIconComponent = IconSpeakbotVocabulary;
        needRotatedCrown = true;
        break;
      case 'purchaseCancel':
        mainIconComponent = IconNewProCrown;
        needRotatedCrown = false;
        isGeneralStyle = false;
        needFindOutMoreButton = false;
        break;
      case 'classroomProContentClicked':
        mainIconComponent = IconSpeakbotVocabulary;
        needRotatedCrown = false;
        isGeneralStyle = false;
        needFindOutMoreButton = false;
        teacherPicture = teacherPic;
        break;
      case 'autoAndManualSales':
        mainIconComponent = IconCrown;
        needRotatedCrown = false;
        modalType = SalesLargeModal;
        congratulationText = this.saleInfo.fullscreenTitle;
        fullScreenDescription = this.saleInfo.fullscreenDescription;
        backgroundUrl = this.saleInfo.webFullscreenImage == null || this.saleInfo.webFullscreenImage == '' ? this.saleInfo.fullscreenImage : this.saleInfo.webFullscreenImage;
        percentageOff = this.saleInfo.discountPercentage;
        renewHint = this.saleInfo.renewHint;
        userInManualSale = this.userInManualSale;
        break;
      case 'resubSales':
        mainIconComponent = IconCrown;
        needRotatedCrown = false;
        isGeneralStyle = false;
        needFindOutMoreButton = false;
        upperPicture = 'https://s3.eu-central-1.amazonaws.com/xeropan-assets/static_files/sale_campaign/resub/sad_doctor.svg';
        break;
      default:
        mainIconComponent = IconCrown;
        needRotatedCrown = true;
    }
    return {
      is: modalType,
      mainIconComponent,
      titleText: `app.sales.popups.${type}.title`,
      descriptionText: `app.sales.popups.${type}.subtitle`,
      cancelText: 'app.sales.cta.no_thanks',
      congratulationText,
      userInManualSale,
      fullScreenDescription,
      backgroundUrl,
      percentageOff,
      renewHint,
      okText,
      type,
      okAction: ok,
      cancelAction: cancel,
      needRotatedCrown,
      needFindOutMoreButton,
      isGeneralStyle,
      upperPicture,
      teacherPicture,
    };
  }

  getThematicBanner(shopAction, settingsAction, timerAvailable = false) {
    let action = shopAction;
    if (this.bannerType === 'grace_period') {
      action = settingsAction;
    }
    return {
      text: this.getThematicBannerTitle(timerAvailable),
      iconName: 'pro-crown',
      btnText: 'app.proPromotionBand.sevenDaysFreeTrialButton',
      action,
      isCountdown: this.getThematicBannerCountdown(timerAvailable) !== null,
      countdownDate: new Date(1000 * this.getThematicBannerCountdown()),
      countdownDistance: timerAvailable,
      product: this.bestDealProduct,
    };
  }

  getLibraryBanner(shopAction, settingsAction, timerAvailable = false) {
    const banner = this.getThematicBanner(shopAction, settingsAction, timerAvailable);
    banner.text = this.getLibraryBannerTitle(timerAvailable);
    banner.isCountdown = this.getLibraryBannerCountdown(timerAvailable) !== null;
    banner.countdownDate = new Date(1000 * this.getLibraryBannerCountdown());
    banner.countdownDistance = timerAvailable;
    banner.product = this.bestDealProduct;
    return banner;
  }

  getIslandBanner(shopAction, settingsAction) {
    const banner = this.getThematicBanner(shopAction, settingsAction);
    banner.text = this.getIslandBannerTitle();
    banner.isCountdown = this.getIslandBannerCountdown() !== null;
    banner.countdownDate = new Date(1000 * this.getIslandBannerCountdown());
    banner.product = this.bestDealProduct;
    return banner;
  }

  getCtaLabel() {
    let label = 'app.proPromotionBand.buttonWithoutProductAfterTrial';
    switch (this.popupCtaType) {
      case 'grace_period':
        label = 'app.proPromotionBand.buttonGracePeriod';
        break;
      case 'product_without_trial':
        // label = i18n.t('app.proPromotionBand.buttonWithProduct', { displayPrice: this.bestDealProduct.displayMonthlyPrice() });
        label = 'app.proPromotionBand.buttonWithProduct';
        break;
      case 'product_with_trial':
        label = 'app.proPromotionBand.buttonWithProduct';
        break;
      case 'no_product_without_trial_pro_title':
        label = 'app.proPromotionBand.buttonWithoutProductAfterTrial';
        break;
      case 'no_product_with_trial_pro_title':
        label = 'app.proPromotionBand.buttonWithoutProductBeforeTrial';
        break;
      case 'no_product_without_trial':
        label = 'app.proPromotionBand.buttonWithoutProductAfterTrial';
        break;
      case 'no_product_with_trial':
        label = 'app.proPromotionBand.buttonWithoutProductBeforeTrial';
        break;
      default:
        label = 'app.proPromotionBand.buttonWithoutProductAfterTrial';
    }
    return label;
  }

  getThematicBannerTitle(timerAvailable = false) {
    if (timerAvailable) {
      return 'app.proPromotionBand.timerAvailable';
    }
    let label = 'app.proPromotionBand.titleWithoutProductAfterTrial';
    switch (this.bannerType) {
      case 'grace_period':
        label = 'app.proPromotionBand.titleGracePeriod';
        break;
      case 'product_without_trial':
        // label = i18n.t('app.proPromotionBand.titleWithProduct', { displayPrice: this.bestDealProduct.displayMonthlyPrice() });
        label = 'app.proPromotionBand.titleWithProduct';
        break;
      case 'product_with_trial':
        label = 'app.proPromotionBand.titleWithProduct';
        break;
      case 'no_product_without_trial_pro_title':
        label = 'app.proPromotionBand.titleWithoutProductAfterTrial';
        break;
      case 'no_product_with_trial_pro_title':
        label = 'app.proPromotionBand.titleWithoutProductBeforeTrial';
        break;
      case 'no_product_without_trial':
        label = 'app.proPromotionBand.titleWithoutProductAfterTrial';
        break;
      case 'no_product_with_trial':
        label = 'app.proPromotionBand.titleWithoutProductBeforeTrial';
        break;
      default:
        label = 'app.proPromotionBand.titleWithoutProductAfterTrial';
    }
    return label;
  }

  getLibraryBannerTitle(timerAvailable) {
    return this.getThematicBannerTitle(timerAvailable);
  }

  getIslandBannerTitle() {
    return this.getThematicBannerTitle();
  }

  getThematicBannerCountdown(timerAvailable = false) {
    let expirationTime = null;
    if (timerAvailable) {
      return true;
    }
    switch (this.bannerType) {
      case 'grace_period':
        expirationTime = null;
        break;
      case 'product_without_trial':
        expirationTime = this.salesEndDate;
        break;
      case 'product_with_trial':
        expirationTime = this.salesEndDate;
        break;
      case 'no_product_without_trial_pro_title':
        expirationTime = null;
        break;
      case 'no_product_with_trial_pro_title':
        expirationTime = null;
        break;
      case 'no_product_without_trial':
        expirationTime = null;
        break;
      case 'no_product_with_trial':
        expirationTime = null;
        break;
      default:
        expirationTime = null;
    }
    return expirationTime;
  }

  getLibraryBannerCountdown(timerAvailable) {
    return this.getThematicBannerCountdown(timerAvailable);
  }

  getIslandBannerCountdown() {
    return this.getThematicBannerCountdown();
  }
}
export default Promotion;
